import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, MessageCircle, Linkedin, ArrowRight, X } from 'lucide-react';

function Footer() {
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", text: "" });

  const socials = [
    { icon: <Facebook size={18} />, link: "https://www.facebook.com/share/1CWqGBmxyK/", color: "hover:bg-blue-600" },
    { icon: <Instagram size={18} />, link: "https://www.instagram.com/zygmasolution?igsh=MTBneHBhbG16Mzljdg==", color: "hover:bg-pink-600" },
    { 
  icon: <MessageCircle size={18} />, 
  link: "https://wa.me/18035409934?text=Hello%20Zygma%20Growth%20Solutions,%20I%20need%20your%20help!", 
  color: "hover:bg-[#25D366] hover:text-white transition-colors duration-300",
  label: "WhatsApp" 
},
    { icon: <Linkedin size={18} />, link: "https://www.linkedin.com/in/zygma-growth-solutions-a3105a295/", color: "hover:bg-blue-700" },
  ];

  const contentData = {
    help: {
      title: "Help Center",
      text: "Welcome to ZYGMA Help Center. We provide 24/7 support for all our digital services. Reach out via info@zygmagrowthsolutions.com for technical assistance or project inquiries. Our goal is to resolve all tickets within 24 hours."
    },
    privacy: {
      title: "Privacy Policy",
      // CRITICAL: Yeh text ClickSend approval ke liye update kiya gaya hai
      text: (
        <>
          At ZYGMA, we prioritize your data security. We collect names, emails, and phone numbers solely for project communication. 
          <br /><br />
          <strong>SMS Privacy:</strong> By opting in, you agree to receive SMS alerts from us. 
          <strong> Mobile information will not be shared with third parties or affiliates for marketing or promotional purposes.</strong> 
          All other categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties. 
          You can opt-out anytime by replying STOP.
        </>
      )
    },
    terms: {
      title: "Terms of Service",
      text: "By using ZYGMA services, you agree to our professional terms. Projects start after formal requirement gathering. Payments are milestone-based. Cancellation of services must be notified 15 days in advance."
    }
  };

  const openModal = (type) => {
    setModalContent(contentData[type]);
    setIsOpen(true);
  };

  return (
    <footer className="bg-gray-900 text-white pt-20 pb-10 border-t border-gray-800 relative">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        
        {/* 1. Brand Section */}
        <div className="space-y-4">
          <h2 className="text-3xl font-black text-blue-500 tracking-tighter">ZYGMA.</h2>
          <p className="text-gray-400 text-sm leading-relaxed">
            Global digital agency driving worldwide growth. We specialize in Strategic Local SEO, GBP Optimization, and high-performance Web Development.
          </p>
        </div>

        {/* 2. Quick Navigation */}
        <div>
          <h3 className="text-white font-bold mb-6 uppercase tracking-widest text-xs">Quick Navigation</h3>
          <ul className="space-y-4">
            <li><Link to="/" className="text-gray-400 hover:text-blue-500 transition-all flex items-center gap-2 group"><ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" /> Home</Link></li>
            <li><a href="#services" className="text-gray-400 hover:text-blue-500 transition-all flex items-center gap-2 group"><ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" /> Services</a></li>
            <li><Link to="/contact" className="text-gray-400 hover:text-blue-500 transition-all flex items-center gap-2 group"><ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" /> Contact Us</Link></li>
          </ul>
        </div>

        {/* 3. Support Section (Modal Links) */}
        <div>
          <h3 className="text-white font-bold mb-6 uppercase tracking-widest text-xs">Support</h3>
          <ul className="space-y-4">
            <li><button onClick={() => openModal('help')} className="text-gray-400 hover:text-white text-sm text-left">Help Center</button></li>
            <li><button onClick={() => openModal('privacy')} className="text-gray-400 hover:text-white text-sm text-left">Privacy Policy</button></li>
            <li><button onClick={() => openModal('terms')} className="text-gray-400 hover:text-white text-sm text-left">Terms of Service</button></li>
          </ul>
        </div>

        {/* 4. Connect Section */}
        <div>
          <h3 className="text-white font-bold mb-6 uppercase tracking-widest text-xs">Connect With Us</h3>
          <div className="flex flex-wrap gap-3">
            {socials.map((social, i) => (
              <a key={i} href={social.link} target="_blank" rel="noreferrer" className={`w-11 h-11 flex items-center justify-center rounded-2xl bg-gray-800/50 border border-gray-700 transition-all duration-300 ${social.color} hover:text-white hover:-translate-y-1`}>
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="max-w-7xl mx-auto px-6 mt-20 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-gray-500 text-xs font-medium">© 2026 ZYGMA Strategic Solutions. All rights reserved.</p>
        <p className="text-gray-600 text-[10px] uppercase tracking-widest">Built with React & Tailwind CSS</p>
      </div>

      {/* --- MODAL DIV --- */}
      {isOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={() => setIsOpen(false)}></div>
          
          <div className="relative bg-white text-gray-900 p-8 md:p-12 rounded-[2rem] max-w-2xl w-full shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-300">
            <button onClick={() => setIsOpen(false)} className="absolute top-6 right-6 text-gray-400 hover:text-red-500 transition-colors">
              <X size={28} />
            </button>
            
            <h3 className="text-2xl font-black mb-6 text-gray-900 border-b pb-4">{modalContent.title}</h3>
            <div className="text-gray-600 leading-relaxed text-base mb-8 text-justify">
              {modalContent.text}
            </div>
            
            <button 
              onClick={() => setIsOpen(false)}
              className="w-full bg-blue-600 hover:bg-slate-900 text-white font-bold py-4 rounded-xl transition-all duration-300 shadow-lg"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </footer>
  );
}

export default Footer;